"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _TreeView = _interopRequireDefault(require("@material-ui/lab/TreeView"));
var _TreeItem = _interopRequireDefault(require("@material-ui/lab/TreeItem"));
var _core = require("@stt-componentes/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function SttCheckboxTreeView(_ref) {
  var arvore = _ref.arvore,
    setArvore = _ref.setArvore,
    strings = _ref.strings;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    mostrarAlerta = _useState2[0],
    setMostrarAlerta = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    identificador = _useState4[0],
    setIndentificador = _useState4[1];
  var onChangeCheckbox = function onChangeCheckbox(identificador, checked) {
    arvore.expanded = [];

    //Atualizar o nodo (des)checkado
    var atualizarNodo = function atualizarNodo(nodo, nodoPai, identificador) {
      if (nodo.identificador === identificador) {
        nodo.checked = checked;
      }
      if (nodoPai && !nodoPai.checked) {
        nodo.checked = false;
      }
      if (nodo.checked) {
        arvore.expanded.push(nodo.identificador);
      }
      nodo.filhos && nodo.filhos.map(function (filho) {
        atualizarNodo(filho, nodo, identificador);
      });
      return arvore;
    };
    setArvore(JSON.parse(JSON.stringify(atualizarNodo(arvore, null, identificador))));
  };
  var gerarLabelCheckbox = function gerarLabelCheckbox(props) {
    return /*#__PURE__*/_react["default"].createElement(_core.SttFormGroup, {
      row: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttFormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_core.SttCheckbox, {
        value: true,
        color: "primary",
        onChange: function onChange(event) {
          if (!event.target.checked && props.filhos && props.filhos.length) {
            setIndentificador(props.identificador);
            setMostrarAlerta(true);
          } else {
            onChangeCheckbox(props.identificador, event.target.checked);
          }
        },
        checked: props.checked
      }),
      label: props.descricao
    }));
  };
  var StyledTreeItem = (0, _styles.withStyles)(function (theme) {
    return {};
  })(function (arvore) {
    return /*#__PURE__*/_react["default"].createElement(_TreeItem["default"], _extends({
      onLabelClick: function onLabelClick(e) {
        return e.preventDefault;
      },
      nodeId: arvore.identificador,
      label: gerarLabelCheckbox(arvore)
    }, arvore), arvore.filhos && arvore.filhos.map(function (galho, index) {
      return /*#__PURE__*/_react["default"].createElement(StyledTreeItem, _extends({
        key: index
      }, galho));
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TreeView["default"], arvore, /*#__PURE__*/_react["default"].createElement(StyledTreeItem, arvore)), /*#__PURE__*/_react["default"].createElement(_core.SttAlerta, {
    open: mostrarAlerta,
    title: strings.atencao,
    message: strings.mensagemConfirmacaoDesselecao,
    type: 'alert',
    options: [{
      title: strings.sim,
      onClick: function onClick() {
        onChangeCheckbox(identificador);
        setMostrarAlerta(false);
      }
    }, {
      title: strings.nao,
      onClick: function onClick() {
        setMostrarAlerta(false);
      }
    }],
    onClose: function onClose() {
      return setMostrarAlerta(false);
    }
  }));
}
var _default = SttCheckboxTreeView;
exports["default"] = _default;